import { createContext } from 'react';
import settlementInitialValues from 'src/data/formDataInitialValues/settlement';
import useForm from 'src/services/useForm';

const FormContext = createContext();

export const SettlementFormProvider = ({ children }) => {
  const value = useForm({
    apiPath: '/settlement',
    createFormData: (data) => {
      const formData = new FormData();

      for (const key in data) {
        formData.append(key, JSON.stringify(data?.[key]));
      }

      formData.append('valuation', data.valuation[0]);
      formData.append('valuation', data.valuation[1]);
      formData.append('other', data.other?.[0]);
      formData.append('other', data.other?.[1]);
      formData.append('personal', data.personal?.[0]);
      formData.append('personal', data.personal?.[1]);

      return formData;
    },
    contacts: [{ name: 'Anna Van Noy', email: 'AnnaV@utahcounty.gov', phone: '(801) 851-8001' }],
    initialValues: settlementInitialValues,
    pageTitle: 'Application for Settlement ',
  });

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

export default FormContext;
